import React, { memo, ReactNode } from 'react'
import ClipboardCopy from 'transfix-ui/components/Copy'
import { IStatus } from 'types'

interface IShipmentStatusProps {
  shipperName?: string
  status?: IStatus
  id: string
  children: ReactNode
}

const ShipmentStatus = memo<IShipmentStatusProps>(({ children, id, shipperName, status }) => {
  const { name: statusName } = status || {}
  const statusText = statusName === 'Waterfall Offered' ? 'Reserved' : statusName

  const shipmentDetailsLink = `${__ROOT__}/shipment-details/${id}`

  return (
    <div className='pl2'>
      <div>
        <strong className='flex items-start'>
          <div className='text-default mr2'>{statusText}</div>
          {children}
        </strong>
      </div>
      <a href={shipmentDetailsLink} target='_blank' rel='noopener noreferrer' className='mr1'>
        #{id}
      </a>
      <ClipboardCopy
        copyText={String(id)}
        displayText={`Shipment #${id} ID`}
        useIcon
        alignClass='left'
      />
      <div className='text-secondary ellipsis'>{shipperName}</div>
    </div>
  )
})

export default ShipmentStatus
